import React from 'react';
import {ReactComponent as Include} from "../../assets/icons/include.svg";
import {ReactComponent as NotInclude} from "../../assets/icons/notInclude.svg";

interface IncludesProps {
    data: {
        included: string[];
        notIncluded: string[];
    };
    loading: boolean;
    error: any;
}

const Includes: React.FC<IncludesProps> = ({ data, loading, error }) => {
    if (loading) {
        return <div></div>
    }

    if (error) {
        return <div></div>
    }

    return (
        <div className='includes__container'>
            {data.included.length > 0 &&
                <>
                    <div className="includes__buttons">
                        <button className="button__includes ">
                            <h2 className="includes__title">Incluye</h2>
                        </button>
                    </div>
                    <div className="incluye">
                        <ul className="includes__ul">
                            {data.included.map((item, index) => (
                                <li key={index}>
                                    <div className="icon icon--green">
                                        <Include/>
                                    </div>
                                    <div className="description">
                                        <p>{item}</p>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <br/>
                </>
            }
            {data.notIncluded.length > 0 &&
                <>
                    <div className="includes__buttons">
                        <button className="button__includes ">
                            <h2 className="includes__title">No incluye</h2>
                        </button>
                    </div>
                    <div className="no-incluye">
                        <ul className="includes__ul">
                            {data.notIncluded.map((item, index) => (
                                <li key={index}>
                                    <div className="icon icon--red">
                                        <NotInclude/>
                                    </div>
                                    <div className="description">
                                        <p>{item}</p>
                                    </div>
                                </li>))}
                        </ul>
                    </div>
                </>
            }
        </div>
    );
};

export default Includes;


